<template>
  <AppDialog
    :show="show"
    :title="title"
    size="medium"
    append-to-body
    @close="close"
  >
    <div
      class="d-flex auto-track-warning-text"
      v-html="text"
    />
    <template #footer>
      <div class="d-flex align-items-end gap-15 flex-row-reverse">
        <AppButton
          :type="confirmType"
          @click="accept"
        >
          {{ confirmLabel }}
        </AppButton>
        <AppButton @click="close"> Cancel </AppButton>
      </div>
    </template>
  </AppDialog>
</template>

<script>
export default {
  name: 'AutoTrackRuleWarningDialog',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    autoTrackRule: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    title() {
      return this.autoTrackRule.active ? 'Archive policy' : 'Restore policy';
    },
    text() {
      const message = this.autoTrackRule.active ? this.archiveMessage : this.restoreMessage;

      return '<p>' + message + '</p>';
    },
    archiveMessage() {
      if (this.autoTrackRule.app_type === 'corporate') {
        if (this.autoTrackRule.auto_add_new_users) {
          return (
            `Members on ${this.autoTrackRuleName} will no longer be able to use the Silent app to ` +
            `track time in the background of their device. <b>New members will also not be added to this policy</b> when ` +
            'they join the organization. Are you sure you want to archive this policy?'
          );
        }

        return (
          `Members on ${this.autoTrackRuleName} will no longer be able to use the Silent app to track ` +
          'time in the background of their device. Are you sure you want to archive this policy?'
        );
      }

      if (this.autoTrackRule.auto_add_new_users) {
        return (
          `Members on ${this.autoTrackRuleName} will no longer be able to have their desktop app start or stop automatically. ` +
          '<b>New members will also not be added to this policy</b> when they join the organization. They will still be able to track time manually. ' +
          'Are you sure you want to archive this policy?'
        );
      }

      return (
        'Members on this policy will no longer have their desktop app start or stop automatically. They will still be able to track time manually. ' +
        'Are you sure you want to archive this policy?'
      );
    },
    restoreMessage() {
      if (this.autoTrackRule.auto_add_new_users) {
        return (
          `Members from ${this.autoTrackRuleName} might have already been assigned to another policy. Restoring ${this.autoTrackRuleName} ` +
          'will remove them from their active policy, and move them to this one. <b>New members will be automatically added to this policy</b> when ' +
          'they join the organization. Are you sure you want to restore this policy?'
        );
      }

      return (
        `Members from ${this.autoTrackRuleName} might have already been assigned to another policy. Restoring ${this.autoTrackRuleName} will ` +
        'remove them from their active policy, and move them to this one. Are you sure you want to restore this policy?'
      );
    },
    confirmLabel() {
      return this.autoTrackRule.active ? 'Archive' : 'Restore';
    },
    confirmType() {
      return this.autoTrackRule.active ? 'danger' : 'primary';
    },
    autoTrackRuleName() {
      return HubstaffUtils.escapeHTML(this.autoTrackRule.name);
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    accept() {
      this.$emit('status-change-accepted');
    },
  },
};
</script>
